
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`PX Blue has seen a lot of really great enhancements behind the scenes in this latest release. Updated code examples Login and Navigation patterns, as well as wider Hybrid support for Cordova.`}</p>
    <p>{`We're also happy to announce that PX Blue has been made 100% open source.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;